import { useSelector } from 'react-redux';

export const ColorRange = () => {
    
    const isInterferenceEnabled = useSelector(
        state => state.CollisionReducer.isInterferenceEnabled
    );
    
    if (!isInterferenceEnabled) return null;

    return (
        <div className="colorRange">
            <div className="circle" style={{ background: "#c2b6a3", color: "white" }}>0.3</div>
            <div className="circle" style={{ background: "#ffffff", color: "black" }}>0.0</div>
            <div className="circle" style={{ background: "#a4c2f4", color: "white" }}>-0.2</div>
            <div className="circle" style={{ background: "#5a79b3", color: "white" }}>-0.4</div>
            <div className="circle" style={{ background: "#002060", color: "white" }}>-0.5</div>
        </div>
    );
};
